module.exports = __webpack_public_path__ + "static/img/topic_문화예술.c1c1c8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topic_문화예술.png
// module id = 4/c+
// module chunks = 0